import React from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from '../../../contexts/ThemeContext'
import { useConfig } from '../../../contexts/ConfigContext'

import {
  MethodsSection,
  MethodsTitle,
  MethodsList,
  MethodItem,
  MethodIcons,
  MethodName
} from '../styles'

const PAYMENT_OPTIONS = [
  { id: 'cash', flag: 'Payment0', labelKey: 'cash', imageIcons: ['cash'] },
  { id: 'knet', flag: 'Payment1', labelKey: 'knet', imageIcons: ['knet'] },
  {
    id: 'credit card',
    flag: 'Payment2',
    labelKey: 'credit card',
    imageIcons: ['visa', 'master']
  },
  {
    id: 'applepay',
    flag: 'Payment3',
    labelKey: 'Apple Pay',
    imageIcons: ['applepay'],
    defaultOn: true
  }
]

const isOptionEnabled = (configs, option) => {
  const value = configs?.[option.flag]
  if (option.defaultOn) {
    return value !== '0' && value !== 0 && value !== false
  }
  return value === '1' || value === 1 || value === true
}

export const PaymentType = (props) => {
  const { payment, handlePayment } = props
  const { t } = useTranslation()
  const [theme] = useTheme()
  const [configState] = useConfig()
  const configs = configState?.configs || {}

  const visible = PAYMENT_OPTIONS.filter((option) => isOptionEnabled(configs, option))

  if (configState?.loading || visible.length === 0) {
    return null
  }

  return (
    <MethodsSection>
      <MethodsTitle>{t('Select Payment Method')}</MethodsTitle>
      <MethodsList>
        {visible.map((option) => {
          const active = payment === option.id
          const isBrandMark = option.id === 'applepay'
          return (
            <MethodItem
              key={`payment-${option.id}`}
              type='button'
              active={active}
              onClick={() => handlePayment(option.id)}
            >
              <MethodIcons $brand={isBrandMark}>
                {(option.imageIcons || []).map((key) => (
                  <img
                    key={key}
                    src={theme?.images?.payment?.[key]}
                    alt={key}
                  />
                ))}
              </MethodIcons>
              <MethodName>{t(option.labelKey)}</MethodName>
            </MethodItem>
          )
        })}
      </MethodsList>
    </MethodsSection>
  )
}
